export const MIN_NUMBER_OF_ITEMS_TO_ENABLE_SORTING = 5;
export const MIN_SEARCH_PHRASE_LENGTH = 1;
export const ITEMS_PER_PAGE = 4;
export const IMAGE_RATIO = '3x4';
export const SORTING_OPTION_KEYS = {
  tag: 'tag',
  name: 'name',
  location: 'location',
};
